import React from 'react';
import { Typography, theme } from '@hiver/hiver-ui-kit';

const Info = ({ text, contClass }) => {
    const additionalClass = contClass ? contClass : "";
    return (
        <div style={styles.container} className={`h-affirm-con ${additionalClass}`}>
            <span className="h-info-icon">i</span>
            <span className="h-affirm-text"><Typography variant="body2" color={theme.palette.gray.black}>{text}</Typography></span>
        </div>
    );
};

const styles = {
    container: {
        display: "flex",
        alignItems: "center",
        width: "80%",
        borderRadius: "5px"
    }
};

export { Info };